export function isAuthenticated() {
    const token = localStorage.getItem('token');
    // Optionally, add logic to check if the token is expired
    return !!token;
  }